import validator from 'validator';

function AddEditChallangesValidation(data) {
  const errors = {};
  if (validator.isEmpty(data.title.trim())) errors.title = 'Please enter challenge title.';
  if (validator.isEmpty(data.description.trim()))
    errors.description = 'Please enter challenge description.';
  if (validator.isEmpty(String(data.content_type).trim()))
    errors.content_type = 'Please enter challenge type.';
  if (validator.isEmpty(String(data.points))) errors.points = 'Please enter challenge points.';

  return { errors, isValid: Object.keys(errors).length <= 0 };
}

export default AddEditChallangesValidation;
